import React from 'react';
import { Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import './registerInvoiceFonts';

const s = StyleSheet.create({
  page: {
    fontFamily: 'CourierPrime',
    padding: 36,
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    borderWidth: 2.5,
    borderColor: '#1a1a1a',
    borderRadius: 8,
    paddingVertical: 50,
    paddingHorizontal: 36,
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#fafafa',
  },
  badge: {
    fontSize: 10,
    fontWeight: 700,
    color: '#9d174d',
    backgroundColor: '#fdf2f8',
    borderWidth: 1,
    borderColor: '#f472b6',
    borderRadius: 4,
    paddingVertical: 3,
    paddingHorizontal: 8,
    marginBottom: 16,
    letterSpacing: 1.5,
    textAlign: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: 2,
    color: '#1a1a1a',
    textAlign: 'center',
    marginBottom: 10,
  },
  rule: {
    width: 140,
    height: 2,
    backgroundColor: '#1a1a1a',
    marginVertical: 14,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#333333',
    letterSpacing: 1,
    textAlign: 'center',
    marginBottom: 6,
  },
  desc: {
    fontSize: 9.5,
    color: '#6b6b6b',
    textAlign: 'center',
    lineHeight: 1.5,
  },
  countBox: {
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#d8d8d8',
    paddingTop: 12,
    alignItems: 'center',
  },
  countText: {
    fontSize: 11,
    fontWeight: 700,
    color: '#1a1a1a',
    letterSpacing: 0.5,
  },
});

/**
 * A bold, high-contrast physical separator page inserted between Ready Stock orders
 * and Production orders in a bulk print job.
 *
 * This allows warehouse/factory floor workers holding a freshly printed physical paper
 * stack to instantly split the shelf-pickup invoices from the manufacturing invoices.
 */
const PrintDividerPage = ({ orderCount }) => (
  <Page size="A4" style={s.page}>
    <View style={s.card}>
      <Text style={s.badge}>PHYSICAL DIVIDER · BATCH SEPARATION</Text>
      <Text style={s.title}>PRODUCTION ORDERS</Text>
      <View style={s.rule} />
      <Text style={s.subtitle}>REQUIRES FACTORY MANUFACTURING</Text>
      <Text style={s.desc}>
        Fabric Printing · Cutting · Sewing · Assembly
      </Text>
      {orderCount ? (
        <View style={s.countBox}>
          <Text style={s.countText}>
            {orderCount} production order{orderCount === 1 ? '' : 's'} follow
          </Text>
        </View>
      ) : null}
    </View>
  </Page>
);

export default PrintDividerPage;
